let env = {};
//HOMOLOG
// env.baseURL = 'https://api.tihrio-homolog.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.tihrio-homolog.ares-saude.com.br/';
// env.mode = 'homolog';

// TIH RIO
// env.baseURL = 'https://api.tihrio.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.tihrio.ares-saude.com.br/';
// env.mode = 'production';

// TIH RIO CONTINGENCIA
env.baseURL = 'https://api.tihrio-contingencia.it4d.com.br/api/v1/';
env.normalURL = 'https://api.tihrio-contingencia.it4d.com.br/';
env.mode = 'contingencia';

// TS DIADEMA PRODUCAO
// env.baseURL = 'https://api.tsdiadema.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.tsdiadema.ares-saude.com.br/';
// env.mode = 'production';

// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.mode = 'homolog';

// TIH SA
// env.baseURL = 'https://api.tsa.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.tsa.ares-saude.com.br/';
// env.mode = 'production';

// env.mode = 'development';

export default env




